class DynamicBackground extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.parentSection = this.closest('section');
		document.addEventListener('variant:change', (event) => {
			const variant = event.detail.variant;
			const variantColor = window.dynamicSectionColorScheme.find(
				(color) => parseInt(color.variantId) === parseInt(variant.id),
			);
			if (variantColor) {
				this.handleVariantChange(variant, variantColor.background);
			}
		});
	}

	handleVariantChange(variant, color) {
		this.parentSection.style.setProperty(
			'--dynamic-section-color-scheme-background',
			color ? color : 'rgb(var(--background-without-opacity))',
		);
	}

	disconnectedCallback() {
		document.removeEventListener('variant:change', this.handleVariantChange);
	}
}

if (!window.customElements.get('dynamic-background')) {
	window.customElements.define('dynamic-background', DynamicBackground);
}
